import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

// True when React Router has at least one in-app entry to pop back to.
export function hasInAppHistory() {
  if (typeof window === 'undefined') return false;
  const idx = window.history?.state?.idx;
  return typeof idx === 'number' ? idx > 0 : false;
}

export function useSmartBack(fallback = '/') {
  const navigate = useNavigate();

  const goBack = useCallback(() => {
    if (hasInAppHistory()) {
      navigate(-1);
    } else {
      navigate(fallback, { replace: true });
    }
  }, [fallback, navigate]);

  return goBack;
}

export default useSmartBack;
